/**
 * @generated SignedSource<<fdd4a346a488bc75b741f7a795eca22f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SessionStartFavouriteQuery$variables = Record<PropertyKey, never>;
export type SessionStartFavouriteQuery$data = {
  readonly me: {
    readonly learner: {
      readonly id: string;
      readonly scrapbook: ReadonlyArray<{
        readonly id: string;
        readonly sticker: string;
      }>;
    } | null | undefined;
  } | null | undefined;
};
export type SessionStartFavouriteQuery = {
  response: SessionStartFavouriteQuery$data;
  variables: SessionStartFavouriteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Account",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Learner",
        "kind": "LinkedField",
        "name": "learner",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 10
              }
            ],
            "concreteType": "ScrapbookPage",
            "kind": "LinkedField",
            "name": "scrapbook",
            "plural": true,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sticker",
                "storageKey": null
              }
            ],
            "storageKey": "scrapbook(first:10)"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SessionStartFavouriteQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SessionStartFavouriteQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "e5c96d89f959cc5fe4cd72c863aeefb8",
    "id": null,
    "metadata": {},
    "name": "SessionStartFavouriteQuery",
    "operationKind": "query",
    "text": "query SessionStartFavouriteQuery {\n  me {\n    learner {\n      id\n      scrapbook(first: 10) {\n        id\n        sticker\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "efa63aa26b268ff47fda31cb8caac116";

export default node;
